import {AreaOverlayType} from '../enums';

/** GA `analysis_type` 파라미터 값 */
export type AnalysisTypeText = '반경' | '다각형' | '행정동';

/** 분석 영역 타입 표기. UI 라벨과 GA `analysis_type` 파라미터 값으로 함께 쓴다 */
export const AREA_OVERLAY_TYPE_TEXT: Record<AreaOverlayType, AnalysisTypeText> =
  {
    [AreaOverlayType.CIRCLE]: '반경',
    [AreaOverlayType.POLYGON]: '다각형',
    [AreaOverlayType.EMD]: '행정동',
  };

/** 영역 선택 없이 툴박스 버튼으로 AI 해설 패널만 연 진입점 */
export const TOOLBOX_ANALYSIS_TYPE = 'toolbox';
